export default {
  name: 'marking--docStatus',
};